import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getAllReferralCommission = createAsyncThunk(
  "referralCommission/getAllReferralCommission",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/referralCommission/getAllReferralCommission",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getReferralCommissionById = createAsyncThunk(
  "referralCommission/getReferralCommissionById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/referralCommission/getReferralCommissionById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateReferralCommission = createAsyncThunk(
  "referralCommission/updateReferralCommission",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/referralCommission/updateReferralCommission",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const referralCommissionPayment = createAsyncThunk(
  "referralCommission/payment",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/referralCommission/payment",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            token: payload.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAllReferralCommissionTotal = createAsyncThunk(
  "referralCommission/getAllReferralCommissionTotal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "referralCommission/getAllReferralCommissionTotal",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            token: payload.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


const initialState = {
  referralCommission: [],
  referralCommissionById: null,
  referralCommissionTotal: [],
  isLoading: false,
  paymentLoading: false,
  paymentSuccessMessage: null,
  paymentErrorMessage: null,
  searchMessage: null,
  updateReferralCommissionSuccessMessage: null,
  updateReferralCommissionErrorMessage: null,
  // pagination fields
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  hasMore: true,
};

const referralCommissionSlice = createSlice({
  name: "referralCommission",
  initialState,
  reducers: {
    resetupdateReferralCommissionMessage: (state) => {
      state.updateReferralCommissionSuccessMessage = null;
      state.updateReferralCommissionErrorMessage = null;
    },
    resetReferralPaymentMessage: (state) => {
      state.paymentSuccessMessage = null;
      state.paymentErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllReferralCommission.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllReferralCommission.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload?.success) {
          state.referralCommission = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchMessage = action.payload?.result?.message || "No data found";
          return;
        }
        const result = action.payload.result || {};
        state.referralCommission = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getAllReferralCommission.rejected, (state, action) => {
        state.isLoading = false;
        state.searchMessage =
          action?.payload?.result?.message || action?.payload || action?.error?.message;
      })
      .addCase(getReferralCommissionById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReferralCommissionById.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
          state.referralCommissionById = [];
        } else {
          state.referralCommissionById = action.payload.result.list;
          state.searchMessage = null;
        }
      })
      .addCase(getReferralCommissionById.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateReferralCommission.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateReferralCommission.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.updateReferralCommissionErrorMessage =
            action.payload.result.message;
        } else {
          state.updateReferralCommissionSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(updateReferralCommission.rejected, (state, action) => {
        state.isLoading = false;
        state.updateReferralCommissionErrorMessage =
          action?.payload?.result?.message || action?.payload || "";
      })
      .addCase(referralCommissionPayment.pending, (state) => {
        state.paymentLoading = true;
        state.paymentSuccessMessage = null;
        state.paymentErrorMessage = null;
      })
      .addCase(referralCommissionPayment.fulfilled, (state, action) => {
        state.paymentLoading = false;
        if (action.payload.success === false) {
          state.paymentErrorMessage = action.payload.message;
        } else {
          state.paymentSuccessMessage = action.payload.message;
        }
      })
      .addCase(referralCommissionPayment.rejected, (state, action) => {
        state.paymentLoading = false;
        state.paymentErrorMessage = action.payload;
      })
      .addCase(getAllReferralCommissionTotal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllReferralCommissionTotal.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.message;
          state.referralCommissionTotal = [];
        } else {
          state.referralCommissionTotal = action.payload.result.list;
          state.searchMessage = null;
        }
      })
      .addCase(getAllReferralCommissionTotal.rejected, (state, action) => {
        state.isLoading = false;
        state.searchMessage = action.payload;
      });
  },
});

export const {
  resetupdateReferralCommissionMessage,
  resetReferralPaymentMessage,
} = referralCommissionSlice.actions;

export default referralCommissionSlice.reducer;